import { WpEventArgs } from './../Common';

export default class SibAuthorizationFailedEventArgs extends WpEventArgs{
    ErrorMessage: string = '';

    constructor(errorMessage: string) {
        super();
        this.ErrorMessage = errorMessage;
    }
}